<template>
  <div id="new-event" class="max-w-2xl mx-auto">
    <h1 class="text-center">New Show</h1>
    <basic-breadcrumb @change="goToSection" class="my-3" :sections="sections" :activeSection="activeSection"></basic-breadcrumb>
    <div class="card-flat">
      <form class="w-full mt-4">
        <div v-for="s in new_series_schemas[activeSection]" :key="s.label">
          <h3 class="mb-2 pb-1 border-b">{{s.label}}</h3>
          <div v-for="d in s.fields" :key="d.label" class='mb-4'>
            <template v-if="d.type!='actions'">
              <label class="block text-gray-700 text-sm font-bold mb-2" for="d.model">
                {{d.label}}
              </label>
              <template v-if="d.type=='select'">
                <div class="relative">
                  <select v-model="s.model[d.model]" class="block appearance-none w-full bg-gray-300 border border-gray-300 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                    <option :value="null" selected disabled>
                      Please select a division
                    </option>
                    <option v-for="v in d.options"  :key="v.value" :value="v.value">
                      {{v.label}}
                    </option>
                  </select>
                  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                  </div>
                </div>
              </template>
              <input v-else-if="d.type=='input'" :type="d.inputType" v-model="s.model[d.model]" :placeholder="d.placeholder" class="text-input focus:outline-none focus:shadow-outline">
              <textarea v-else-if="d.type=='textArea'" v-model="s.model[d.model]" :placeholder="d.label" rows="4" class="text-input"/>
              <input v-else-if="d.type=='checkbox'" v-model="s.model[d.model]" class="mr-2 leading-tight" type="checkbox">
              <span v-if="d.hint" class="text-sm text-gray-600">{{d.hint}}</span>
            </template>
            <template v-else>
              <div class="flex justify-center">
                <button v-for="a in d.actions" :key="a.buttonText" @click="a.onSubmit" class="btn btn-blue" type="button">
                  {{a.buttonText}}
                </button>
              </div>
            </template>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import BasicBreadcrumb from '@/components/BasicBreadcrumb'
export default {
  components: {
    BasicBreadcrumb
  },
  name: 'new-event',
  data () {
    return {
      series: {
        series_details: {},
        series_settings: {},
        point_settings: {},
        shows: {}
      },
      sections: [
        'Basic',
        'Settings'
      ],
      sectionIndex: 0,
      activeSchema: null
    }
  },
  methods: {
    createSeries () {
      if (this.validateBeforeNextSection()) {
        var re = new RegExp(' ', 'g')

        var newSeries = {
          name: this.series.name,
          series_settings: JSON.stringify(this.series.series_settings),
          series_details: JSON.stringify(this.series.series_details),
          series_identifier: this.series.name.toLowerCase().trim().replace(re, '-'),
          admin_id: this.$store.getters.getUserID,
          // TODO: Move setting this to the DB
          created_by: this.$store.getters.getUserID,
          point_settings: JSON.stringify(this.series.point_settings)
        }
        // this.$parent.apiInstance.post('/data/events', newEvent)
        this.$store.state.apiInstance.post('/data/showSeries', newSeries)
          .then(result => {
            this.notie.alert({
              type: 1,
              text: 'Series created successfully'
            })
            this.$router.push({
              path: `/show-series/${result.data.data.series_identifier}`
            })
          })
          .catch(() => {
            // console.log(error)
            this.notie.alert({
              type: 3,
              text: `Error creating Series, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
            })
            // this.$honeybadger.notify(error)
          })
      }
    },
    goToNextSection () {
      if (this.validateBeforeNextSection()) {
        this.sectionIndex++
      }
    },
    goToPreviousSection () {
      this.sectionIndex--
    },
    goToSection (index) {
      if (index < this.sectionIndex) {
        this.sectionIndex = index
      } else {
        for (let i = this.sectionIndex; i <= index; i++) {
          if (!this.validateBeforeNextSection()) {
            if (this.sectionIndex > i) {
              this.sectionIndex = i - 1
            }
            break
          } else {
            this.sectionIndex = i
          }
        }
      }
    },
    validateBeforeNextSection () {
      var isValid = true
      // console.log(this.activeSection)
      this.new_series_schemas[this.activeSection].forEach(s => {
        s.fields.forEach(f => {
          if (f.required && !(s.model[f.model] || s.model[f.model !== ''])) {
            if (isValid) {
              this.notie.alert({
                type: 3,
                text: `<b>${f.label} is required</b><br>Please update all fields and try again.`
              })
            }
            isValid = false
          }
        })
      })
      return isValid
    }
  },
  computed: {
    new_series_schemas () {
      return {
        'Basic': [
          {
            label: 'Basic',
            model: this.series,
            fields: [
              {
                type: 'input',
                inputType: 'text',
                label: 'Name of Series',
                model: 'name',
                placeholder: 'Series name',
                required: true
              },
              {
                type: 'actions',
                actions: [
                  {
                    buttonText: 'Next',
                    onSubmit: this.goToNextSection,
                    validateBeforeSubmit: true
                  }
                ]
              }
            ]
          }
        ],
        'Settings': [
          {
            label: 'Series Info',
            model: this.series.series_details,
            fields: [
              {
                type: 'input',
                inputType: 'text',
                label: 'Series Contact name',
                model: 'contact_name',
                rquired: true
              },
              {
                type: 'input',
                inputType: 'text',
                label: 'Series Contact Email',
                model: 'contact_email',
                rquired: true
              },
              {
                type: 'input',
                inputType: 'text',
                label: 'Series Contact Phone',
                model: 'contact_phone',
                rquired: false
              },
              {
                type: 'input',
                inputType: 'text',
                label: 'Series Facebook Page',
                model: 'facebook_page',
                rquired: false
              },
              {
                type: 'input',
                inputType: 'text',
                label: 'Series Website',
                model: 'website',
                rquired: false
              },
              {
                type: 'actions',
                actions: [
                  {
                    buttonText: 'Back',
                    onSubmit: this.goToPreviousSection,
                    validateBeforeSubmit: false
                  },
                  {
                    buttonText: 'Create Series',
                    onSubmit: this.createSeries,
                    validateBeforeSubmit: true
                  }
                ]
              }
            ]
          }
        ]
      }
    },
    activeSection () {
      return this.sections[this.sectionIndex]
    }
  },
  mounted () {
    this.activeSchema = this.overview_schema
  }
}
</script>

<style>

</style>
